import { path, prop, pipe, map, keys, __ } from 'ramda'
import { createSelector } from 'reselect'

const companyUsersSelector = createSelector(
  path(['companyManagement', 'users']),
  path(['session', 'company_users']),
  (users, companyUsers) => pipe(keys, map(prop(__, users)))(companyUsers)
)
export { companyUsersSelector }
